<template>
<div class="loader">
  <div class="spinner-border" :style="{width: `${size}rem`, height: `${size}rem`}" role="status">
    <span class="sr-only"></span>
  </div>
</div>
</template>

<script>
export default {
  name: "Loader",
  props: {
    size: {
      default: 2
    }
  },

}
</script>

<style lang="scss" scoped>
  .loader {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
  }
</style>
